/**
 * External dependencies
 */
import $ from 'jquery';

/*
 * Internal dependencies
 */

import './modules/el-popup.js'
import './modules/win-reload.js'
import './modules/custom-translation';
import './modules/createVueApp';
import './modules/init-swiper';
import './modules/modal';
import './modules/modal-expand';
import './modules/listing-posts-load-more';
import './modules/elementor-swiper';
import './modules/set-utm-data-cookie';
import './modules/gravity-forms-field-validation';
import plansSubmitButton from './modules/plan-form';
import './modules/new-lead-form';
import './modules/widget-chat';
import './modules/load-more';
import './modules/header-dynamic-number';
import './modules/set-lead-id';
import './modules/events-conversions-mapping';
import './modules/destination-country-event';

plansSubmitButton()
